import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

// import DarkStoresTab from "./dsstores";
import DarkStoresTab from "./dsstores2.js";
import WarehousesTab from "./warehouses";
import STNStockStatus from "./stnstockstatus.js";

import WarehousesAllApi from "./warehousesallapi.js";


const tabs = [
  { label: "Dark Stores", value: "dark_stores" },
  { label: "Warehouses", value: "warehouses" },
  { label: "STN", value: "stn" },
];

const StockStatusParent = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const defaultTab = searchParams.get("tab") || "dark_stores";
  const [activeTab, setActiveTab] = useState(defaultTab);

  // 🔄 Keep URL in sync with selected tab
  useEffect(() => {
    setSearchParams({ tab: activeTab });
  }, [activeTab, setSearchParams]);

  // 👇 Handle tab click
  const handleTabClick = (tabValue) => {
      setActiveTab(tabValue);
  };

  return (
    <div className="container mt-4 pl-2 pr-2">
      
       <div className="col-sm-12 p-0 mt-3">
          <ul className="nav nav-tabs" role="tablist" style={{ borderBottom: "1px solid #dee2e6" }}>
            {tabs.map((tab) => (
              <li key={tab.value} className="nav-item" role="presentation">
                <button
                  type="button"
                  className={`nav-link ${activeTab === tab.value ? "active" : ""}`}
                  onClick={() => handleTabClick(tab.value)}
                  style={{
                    fontSize: "14px",
                    fontWeight: activeTab === tab.value ? 600 : 500,
                    color: activeTab === tab.value ? "#93385D" : "#555",
                    backgroundColor: activeTab === tab.value ? "#fff" : "#f8f9fa",
                    border: "none",
                    borderBottom: `2px solid ${
                      activeTab === tab.value ? "#93385D" : "transparent"
                    }`,
                    padding: "8px 20px",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                  }}
                >
                  {tab.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

      {/* ---------- Tab Content ---------- */}
      <div style={{ marginTop: "30px", fontSize: "16px" }}>
        {activeTab === "dark_stores" && <DarkStoresTab />}
        {activeTab === "warehouses" && <WarehousesAllApi />}
        {activeTab === "stn" && <STNStockStatus />}
      </div>
    </div>
  );
};

export default StockStatusParent;
